module.exports = __webpack_public_path__ + "img/virtual_tour.31c6f756.jpg";